module.exports = __webpack_public_path__ + "img/sign.0a213717.svg";